import type { FC } from "react";
import { Stack } from "@mui/material";
import { Likes } from "./Likes";
import { FavoriteButton } from "./FavoriteButton";
import { ShareButton } from "./ShareButton";
import type { ContentQueryType } from "@/types/graphql/site.generated";

type Content = NonNullable<ContentQueryType["content"]>;

// Порт референсного ContentBody/ContentControls: ряд outlined-кнопок
// лайк/дизлайк | избранное | поделиться (без Paper-«пилюли» и Divider —
// каждая кнопка сама себе рамка, см. тему Task 2). Share показывается
// всегда, остальное — по флагам платформы.
export const ContentControls: FC<{
  content: Content;
  isLikesEnabled: boolean;
  isFavoritesEnabled: boolean;
}> = ({ content, isLikesEnabled, isFavoritesEnabled }) => {
  const shareUrl = content.shareUrl ? String(content.shareUrl) : "";

  return (
    // На узком экране кнопки переносятся на вторую строку. Раньше ряд был
    // горизонтальной прокруткой, но родитель выравнивает его по левому краю
    // (alignItems: flex-start), ряд рос шире экрана и последняя кнопка
    // («Поделиться») просто обрезалась, а не прокручивалась.
    <Stack
      direction="row"
      useFlexGap
      gap={1.25}
      sx={{
        flexWrap: { xs: "wrap", md: "nowrap" },
        flexShrink: 0,
        maxWidth: "100%",
      }}
    >
      {isLikesEnabled && (
        <Likes contentId={content.id} likes={content.likes ?? null} />
      )}
      {isFavoritesEnabled && <FavoriteButton contentId={content.id} />}
      <ShareButton title={content.title} url={shareUrl} />
    </Stack>
  );
};
